// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1rOwl","productName":"Table_productName__1GZ9-"};